import actions from "./actions";

const {
    FETCH_ALL_STUDENT_EMAILS,
    FETCH_ALL_STUDENT_INFO,
    FETCH_ALL_TEACHER_EMAILS,
    FETCH_ALL_TEACHER_INFO,
    FETCH_TEACHER_EMAILS,
    FETCH_TEACHER_SENT_EMAILS,
    FETCH_TEACHER_UNIFIED_EMAILS,
    FETCH_STUDENT_EMAILS,
    FETCH_ALL_OFFICIAL_EMAILS,
    FETCH_CLASS_TEACHER_ZOOM_EMAILS
} = actions;

const initState = {
    allStudentInfo: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    allStudentEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    allTeacherInfo: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    allTeacherEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    teacherEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    teacherSentEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    teacherUnifiedEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    studentEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    classTeacherZoomEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0
    },
    allOfficialEmails: {
        page: 0,
        perPage: 20,
        data: [],
        total: 0,
        userEmails: []
    },
};

const TeacherEmailReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_ALL_STUDENT_EMAILS:
            return {
                ...state,
                allStudentEmails: data
            };

        case FETCH_ALL_STUDENT_INFO:
            return {
                ...state,
                allStudentInfo: data
            };
        case FETCH_ALL_TEACHER_EMAILS:
            return {
                ...state,
                allTeacherEmails: data
            };
        case FETCH_ALL_TEACHER_INFO:
            return {
                ...state,
                allTeacherInfo: data
            };
        case FETCH_TEACHER_EMAILS:
            return {
                ...state,
                teacherEmails: data
            };
        case FETCH_TEACHER_SENT_EMAILS:
            return {
                ...state,
                teacherSentEmails: data
            };
        case FETCH_TEACHER_UNIFIED_EMAILS:
            return {
                ...state,
                teacherUnifiedEmails: data
            };
        case FETCH_STUDENT_EMAILS:
            return {
                ...state,
                studentEmails: data
            };
        case FETCH_CLASS_TEACHER_ZOOM_EMAILS:
            return {
                ...state,
                classTeacherZoomEmails: data
            };
        case FETCH_ALL_OFFICIAL_EMAILS:
            return {
                ...state,
                allOfficialEmails: data
            };
        default:
            return state;
    }
};

export default TeacherEmailReducer;
